export const TESTIMONIALS_ASSETS_DIR = '/assets/shared/testimonials';
export const LOGOS_ASSETS_DIR = '/assets/shared/companies-logos';
